export var GoalImpact;
(function (GoalImpact) {
    GoalImpact[GoalImpact["LOW"] = 1] = "LOW";
    GoalImpact[GoalImpact["MEDIUM"] = 2] = "MEDIUM";
    GoalImpact[GoalImpact["HIGH"] = 3] = "HIGH";
})(GoalImpact || (GoalImpact = {}));
